const apiServerAdress = import.meta.env.VITE_API_SERVER_ADDRESS;

export default { apiServerAdress }
